export default __webpack_public_path__ + "static/media/logo.3aded7b5.svg";